import TYPES from '../actions/types';

const INITIAL_STATE = {
    list: [],
    paging: {},
    filter: {},
    selected: null
};

export const studentDegreeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TYPES.SET_STUDENT_DEGREES:
            const { count, current, page, pageCount, sort, direction } = action.payload.paging;
            return {
                ...state, 
                list: action.payload.list, 
                paging: { count, current, page, pageCount, sort, direction }
            };

        case TYPES.SET_STUDENT_DEGREE_FILTER:
            return {
                ...state,
                filter: action.payload,
                paging: {}
            };

        case TYPES.SELECT_STUDENT_DEGREE:
            return {
                ...state,
                selected: action.payload
            };
        
        default:
            return state;
    }
};